import React from 'react'
import css from '../../style.module.scss'
import cn from 'classnames'
import {
  InputText,
  Button,
  Phone,
} from 'components/ui'
import { orderFieldNames } from '../../../../constants'
import PropTypes from 'prop-types'

OrderForOthers.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  onClickPreviousButton: PropTypes.func.isRequired
}

export default function OrderForOthers({
  onClickPreviousButton,
  handleChange,
  handleSubmit,
  setFieldValue,
  values,
  errors,
  touched,
  cityName,
  serverError,
}) {
  return (
    <div className={css.orderForOthers}>
      <button
          className="linkBack label-2 primary-color a"
          onClick={onClickPreviousButton}>
        Назад
      </button>

      <div className={css.toWhom}>

        <p className={cn("label-2", "dark-grey", css.label)}>Я заказываю набор:</p>
        <div className={css.prevValues}>
          <p className="body-text black">{`Для других в г. ${cityName}`}</p>
        </div>

      </div>

      <div className={cn("form-layout", css.personData)}>
        <form onSubmit={handleSubmit}>

          <div className="form-field">
            <InputText
              placeholder="Фамилия"
              name={orderFieldNames.OTHER_LASTNAME}
              value={values[orderFieldNames.OTHER_LASTNAME]}
              onChange={handleChange}
              error={touched[orderFieldNames.OTHER_LASTNAME] && errors[orderFieldNames.OTHER_LASTNAME]}
            />
          </div>

          <div className="form-field">
            <InputText
              placeholder="Имя"
              name={orderFieldNames.OTHER_NAME}
              value={values[orderFieldNames.OTHER_NAME]}
              onChange={handleChange}
              error={touched[orderFieldNames.OTHER_NAME] && errors[orderFieldNames.OTHER_NAME]}
            />
          </div>

          <div className="form-field">
            <InputText
              placeholder="Отчество"
              name={orderFieldNames.OTHER_PATRONYMIC}
              value={values[orderFieldNames.OTHER_PATRONYMIC]}
              onChange={handleChange}
              error={touched[orderFieldNames.OTHER_PATRONYMIC] && errors[orderFieldNames.OTHER_PATRONYMIC]}
            />
          </div>

          <div className="form-field">
            <InputText
              placeholder="Кем приходится человек, для которого вы делаете заказ"
              name={orderFieldNames.OTHER_KINSHIP}
              value={values[orderFieldNames.OTHER_KINSHIP]}
              onChange={handleChange}
              error={touched[orderFieldNames.OTHER_KINSHIP] && errors[orderFieldNames.OTHER_KINSHIP]}
            />
          </div>

          <div className="form-field">
            <Phone
              placeholder="Номер телефона"
              name={orderFieldNames.OTHER_PHONE}
              setFieldValue={setFieldValue}
              error={touched[orderFieldNames.OTHER_PHONE] && errors[orderFieldNames.OTHER_PHONE]}
              country={'ru'}
            />
          </div>

          <div className="form-field">
            <InputText
              placeholder="E-mail"
              name={orderFieldNames.OTHER_EMAIL}
              value={values[orderFieldNames.OTHER_EMAIL]}
              onChange={handleChange}
              error={touched[orderFieldNames.OTHER_EMAIL] && errors[orderFieldNames.OTHER_EMAIL]}
            />
          </div>

          <div className="form-field">
            <InputText
              placeholder="Адрес доставки"
              name={orderFieldNames.ADDRESS}
              value={values[orderFieldNames.ADDRESS]}
              onChange={handleChange}
              error={touched[orderFieldNames.ADDRESS] && errors[orderFieldNames.ADDRESS]}
            />
          </div>

          <div className="form-field">
            <InputText
              placeholder="Количество членов семьи"
              name={orderFieldNames.OTHER_FAMILY_COUNT}
              value={values[orderFieldNames.OTHER_FAMILY_COUNT]}
              onChange={handleChange}
              error={touched[orderFieldNames.OTHER_FAMILY_COUNT] && errors[orderFieldNames.OTHER_FAMILY_COUNT]}
            />
          </div>

          <div>
            {
              serverError && 
                <React.Fragment>
                  <p className="caption red">{serverError}</p>
                  <p><br /></p>
                </React.Fragment>
            }
            <Button blue className="form-button" text={'Заказать'} type='submit' />
          </div>
        </form>

      </div>

    </div>
  )
}
